import React, { useEffect, useState } from "react";

import { LoadingPage } from "@/components/LoadingPage";
import { useAuthStore } from "@/store/auth.store";
import { allPageRoutes } from "@/utils/routes.utils";

const withAuth = <P extends object>(Component: React.ComponentType<P>) => {
  const AuthWrapper = (
    props: P & { location: { pathname: string; search: string } },
  ) => {
    const { isLoggedIn, authInitialized } = useAuthStore();
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
      if (authInitialized) {
        if (!isLoggedIn) {
          const { pathname, search } = props.location;
          window.location.href = allPageRoutes.signin({
            queryParams: `dest=${encodeURIComponent(`${pathname}${search}`)}`,
          });
        } else {
          setShouldRender(true);
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, authInitialized]);

    if (!shouldRender) {
      return <LoadingPage />;
    }

    return <Component {...props} />;
  };

  AuthWrapper.displayName = `withAuth(${Component.displayName || Component.name})`;
  return AuthWrapper;
};

export { withAuth };
